<template>
  <div>
    <div class="row mb-4">
      <div class="col">
        <router-link to="/integrations" class="btn btn-secondary btn-no-r">
          Insigths
        </router-link>
        <router-link
          to="/integrations/ratings"
          class="btn btn-secondary btn-no-r btn-no-l"
        >
          Ratings
        </router-link>
        <router-link
          to="/integrations/posts/feed"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Posts
        </router-link>
        <router-link
          to="/integrations/posts/tagged"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Tagged
        </router-link>
        <router-link
          to="/integrations/campains"
          class="btn btn-no-l btn-primary"
        >
          Ads
        </router-link>
      </div>
    </div>
    <!-- KPI CARDS -->
    <div class="row g-3 mb-5">
      <div class="col-md-3">
        <div
          class="kpi-card"
          style="background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)"
        >
          <div class="top-row">
            <h5>Instagram</h5>
            <div class="kpi-number large">
              {{
                formatCurrency(
                  platformStats.instagram?.spend,
                  platformStats.instagram?.currency
                )
              }}
              <small style="font-size: 0.6em">Spent</small>
              <div class="regular-12">
                {{ platformStats.instagram?.percent_change }}% vs last 7 days
                <BaseIcon
                  name="trend-up"
                  v-if="platformStats.instagram?.is_up"
                />
                <BaseIcon name="trend-down" v-else />
              </div>
            </div>
          </div>
          <div class="kpi-values">
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.instagram?.reach) }}</div>
              <small>Reach</small>
            </div>
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.instagram?.clicks) }}</div>
              <small>Clicks</small>
            </div>
            <div class="kpi-number">
              <div>{{ platformStats.instagram?.ctr }}%</div>
              <small>CTR</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          class="kpi-card"
          style="background: linear-gradient(135deg, #1877f2, #3b5998)"
        >
          <div class="top-row">
            <h5>Facebook</h5>
            <div class="kpi-number large">
              {{
                formatCurrency(
                  platformStats.facebook?.spend,
                  platformStats.facebook?.currency
                )
              }}
              <small style="font-size: 0.6em">Spent</small>
              <div class="regular-12">
                {{ platformStats.facebook?.percent_change }}% vs last 7 days
                <BaseIcon
                  name="trend-up"
                  v-if="platformStats.facebook?.is_up"
                />
                <BaseIcon name="trend-down" v-else />
              </div>
            </div>
          </div>
          <div class="kpi-values">
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.facebook?.reach) }}</div>
              <small>Reach</small>
            </div>
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.facebook?.clicks) }}</div>
              <small>Clicks</small>
            </div>
            <div class="kpi-number">
              <div>{{ platformStats.facebook?.ctr }}%</div>
              <small>CTR</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="kpi-card brand-tiktok">
          <div class="top-row">
            <h5>TikTok</h5>
            <div class="kpi-number large">
              {{
                formatCurrency(
                  platformStats.tiktok?.spend,
                  platformStats.tiktok?.currency
                )
              }}
              <small style="font-size: 0.6em">Spent</small>
              <div class="regular-12">
                {{ platformStats.tiktok?.percent_change }}% vs last 7 days
                <BaseIcon name="trend-up" v-if="platformStats.tiktok?.is_up" />
                <BaseIcon name="trend-down" v-else />
              </div>
            </div>
          </div>
          <div class="kpi-values">
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.tiktok?.reach) }}</div>
              <small>Reach</small>
            </div>
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.tiktok?.clicks) }}</div>
              <small>Clicks</small>
            </div>
            <div class="kpi-number">
              <div>{{ platformStats.tiktok?.ctr }}%</div>
              <small>CTR</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div
          class="kpi-card"
          style="background: linear-gradient(135deg, #ff8c00, #ffb84d)"
        >
          <div class="top-row">
            <h5>Google</h5>
            <div class="kpi-number large">
              {{
                formatCurrency(
                  platformStats.google?.spend,
                  platformStats.google?.currency
                )
              }}
              <small style="font-size: 0.6em">Spent</small>
              <div class="regular-12">
                {{ platformStats.google?.percent_change }}% vs last 7 days
                <BaseIcon name="trend-up" v-if="platformStats.google?.is_up" />
                <BaseIcon name="trend-down" v-else />
              </div>
            </div>
          </div>
          <div class="kpi-values">
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.google?.reach) }}</div>
              <small>Reach</small>
            </div>
            <div class="kpi-number">
              <div>{{ formatNumber(platformStats.google?.clicks) }}</div>
              <small>Clicks</small>
            </div>
            <div class="kpi-number">
              <div>{{ platformStats.google?.ctr }}%</div>
              <small>CTR</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <!-- LEFT COLUMN -->
      <div class="col-lg-8">
        <div class="card card-clean p-4 mb-4">
          <h4 class="fw-bold mb-3">Active Campaigns</h4>

          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Campaign</th>
                <th>Spend</th>
                <th>Clicks</th>
                <th>CTR</th>
                <th>Orders</th>
                <th>Revenue</th>
                <th>ROAS</th>
                <th>Platform</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(campaign, index) in activeCampaigns" :key="index">
                <td>
                  <strong>{{ campaign.campaign }}</strong>
                </td>
                <td>{{ formatCurrency(campaign.spend, campaign.currency) }}</td>
                <td>{{ formatNumber(campaign.clicks) }}</td>
                <td>{{ campaign.ctr }}%</td>
                <td>{{ formatNumber(campaign.orders) }}</td>
                <td>
                  {{ formatCurrency(campaign.revenue, campaign.currency) }}
                </td>
                <td>{{ campaign.roas }}x</td>
                <td class="text-capitalize">{{ campaign.platform }}</td>
              </tr>
              <tr v-if="activeCampaigns.length === 0">
                <td colspan="8" class="text-center text-muted">
                  No active campaigns found
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- PERFORMANCE CHART -->
        <div class="card card-clean p-4">
          <h4 class="fw-bold mb-3">Campaign Performance</h4>
          <LineChart
            :chartData="performanceChartData"
            :options="chartOptions"
          />
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="col-lg-4">
        <div class="card card-clean p-4 mb-4">
          <h4 class="fw-bold mb-3">Ad Spend Breakdown</h4>
          <PieChart :chartData="spendPieData" :options="pieOptions" />
        </div>

        <div class="card card-clean p-4 mb-4">
          <h4 class="fw-bold mb-3">Top Performing Ad</h4>
          <div class="text-center" v-if="topAd">
            <div
              class="
                ad-thumb
                mx-auto
                mb-3
                d-flex
                align-items-center
                justify-content-center
                bg-light
                border
              "
              style="width: 120px; height: 120px; border-radius: 8px"
            >
              <i class="fas fa-ad fa-3x text-secondary"></i>
            </div>
            <h5 class="fw-bold">{{ topAd.name }}</h5>
            <p class="small text-muted mb-1">CTR: {{ topAd.ctr }}%</p>
            <p class="small text-muted mb-1">
              Spend: {{ formatCurrency(topAd.spend, topAd.currency) }}
            </p>
            <p class="small text-muted mb-1 text-capitalize">
              Platform: {{ topAd.platform }}
            </p>
            <p class="small text-muted">Campaign: {{ topAd.campaign }}</p>
          </div>
          <div class="text-center text-muted" v-else>No data available</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import http from "@/modules/http";
import date from "@/modules/date";
import { LineChart, PieChart } from "vue-chart-3";
import BaseIcon from "../../../components/icons/BaseIcon.vue";

export default {
  name: "campains",
  components: { BaseIcon, LineChart, PieChart },
  data() {
    return {
      store: useStore(),
      services: [],
      pages: [],
      platformStats: {},
      activeCampaigns: [],
      topAd: null,
      performanceChart: [],
      spendBreakdown: [],
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
        },
      },
      pieOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      },
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    path() {
      return this.$route.path;
    },
    performanceChartData() {
      return {
        labels: this.performanceChart.map((d) => d.date),
        datasets: [
          {
            label: "Spend ($)",
            data: this.performanceChart.map((d) => d.spend),
            borderColor: "#1877f2",
            backgroundColor: "rgba(24, 119, 242, 0.1)",
            fill: true,
          },
          {
            label: "Clicks",
            data: this.performanceChart.map((d) => d.clicks),
            borderColor: "#fe2c55",
            backgroundColor: "transparent",
          },
        ],
      };
    },
    spendPieData() {
      const colors = {
        facebook: "#1877f2",
        instagram: "#e4405f",
        tiktok: "#000000",
        google: "#4285f4",
      };
      return {
        labels: this.spendBreakdown.map((d) => d.platform),
        datasets: [
          {
            data: this.spendBreakdown.map((d) => d.total_spend),
            backgroundColor: this.spendBreakdown.map(
              (d) => colors[d.platform.toLowerCase()] || "#cccccc"
            ),
          },
        ],
      };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(val) {
      return date.format(val, true, false);
    },
    login(service = null) {
      http
        .fetch(`/service-integrations/login/${service ?? this.selectedService}`)
        .then((data) => {
          location.href = data.redirect;
        });
    },
    formatNumber(num) {
      if (num === undefined || num === null) return "0";
      if (typeof num === "string") num = parseFloat(num);
      if (isNaN(num)) return "0";
      if (num < 1000) return num.toFixed(2);

      if (num >= 1000 && num < 1000000) {
        return (num / 1000).toFixed(1) + " K";
      }

      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + " M";
      }

      return num.toString();
    },
    formatCurrency(num, currency = "USD") {
      if (num === undefined || num === null) return "-";
      const symbols = {
        USD: "$",
        EUR: "€",
        GBP: "£",
        HUF: "Ft",
      };
      const symbol = symbols[currency] || currency;
      const formatted = this.formatNumber(num);

      if (symbols[currency]) {
        return currency === "HUF"
          ? `${formatted} ${symbol}`
          : `${symbol}${formatted}`;
      }
      return `${formatted} ${currency}`;
    },
    loadData() {
      let url = "/service-integrations/campains";
      http.fetch(url).then((data) => {
        this.platformStats = data.platform_stats;
        this.activeCampaigns = data.active_campaigns;
        this.topAd = data.top_performing_ad;
        this.performanceChart = data.performance_chart;
        this.spendBreakdown = data.spend_breakdown;
      });
    },
  },
};
</script>
<style scoped>
.kpi-card {
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(35, 40, 50, 0.06);
  color: #fff;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.kpi-card h5 {
  font-weight: 700;
  margin-bottom: 15px;
}
.kpi-values {
  display: flex;
  justify-content: space-between;
}
.kpi-values div {
  text-align: center;
  flex: 1;
}
.kpi-values .kpi-number:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}
.brand-tiktok {
  background: linear-gradient(
    135deg,
    #fe2c55,
    #fe2c55 45%,
    #642828 80%,
    #0f5e5c 90%,
    #25f4ee 100%
  );
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1em;
}

.top-row h5 {
  margin: 0;
  font-weight: 700;
}

.top-row .kpi-number.large {
  font-size: 1.5em;
  font-weight: 700;
  text-align: right;
  line-height: 0.9;
}
</style>
